import { configureStore, combineReducers } from "@reduxjs/toolkit";

import authReducer from "features/auth/authSlice";
import authDialogReducer from "features/authDialog/authDialogSlice";
import backgroundReducer from "features/background/backgroundSlice";
import headerReducer from "features/header/headerSlice";
import residenceReducer from "features/calculator/residence/residenceSlice";
import transportReducer from "features/calculator/transport/transportSlice";
import energyReducer from "features/calculator/energy/energySlice";
import nutritionReducer from "features/calculator/nutrition/nutritionSlice";
import householdHabitsReducer from "features/calculator/householdHabits/householdHabitsSlice";

import appReducer from "./appSlice";

export const store = configureStore({
  reducer: {
    app: appReducer,
    auth: authReducer,
    authDialog: authDialogReducer,
    header: headerReducer,
    background: backgroundReducer,
    calculator: combineReducers({
      residence: residenceReducer,
      transport: transportReducer,
      energy: energyReducer,
      nutrition: nutritionReducer,
      householdHabits: householdHabitsReducer,
    }),
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
